import { ChartPoint } from "./DeviceHeatingChart";

type ChartLegendProps= {
  active?: boolean;
  label?: number;
  payload?: any[];
};

export const ChartLegend: React.FC<ChartLegendProps> = ({
  active,
  label,
  payload,
}) => {
  if (!active || !payload || !payload.length) return null;

  const data = payload[0].payload as ChartPoint;
  const ts = label!;
  const dayMs = 24 * 60 * 60 * 1000;
  
  // time within day (region-correct already)
  const t = ts % dayMs;

  const hh = Math.floor(t / 3600000).toString().padStart(2, "0");
  const mm = Math.floor((t % 3600000) / 60000).toString().padStart(2, "0");

  // date part (still need calendar, but avoid locale shift)
  const d = new Date(ts);
  const MMM = d.toLocaleString("en-US", { month: "short", timeZone: "UTC" });
  const DD = d.getUTCDate().toString().padStart(2, "0");
  
  return (
    <div
      style={{
        background: "rgba(255,255,255,0.40)",
        border: "1px solid #ccc",
        padding: "8px 12px",
        fontSize: 13,
      }}
    >
      {/* Time header */}
      <div style={{ fontWeight: 600, marginBottom: 6 }}>
        {MMM} {DD}, {hh}:{mm}
      </div>

      {/* Price */}
      <div>
        <strong>Price:</strong> {(data.price/10).toFixed(2)} c€/kWh
      </div>

      {/* Heating window */}
      {data.heating === 1 && (
        <div style={{ marginTop: 4 }}>
          <strong>Heating:</strong> ON
        </div>
      )}

      {/* Consumption */}
      {data.consumption != null && (
        <div style={{ marginTop: 4 }}>
          <strong>Consumption:</strong>{" "}
          {(data.consumption/1000).toFixed(2)} kWh
        </div>
      )}

      {/* Due marker */}
      {data.dueMarker === 1 && (
        <div style={{ marginTop: 4, color: "red" }}>
          ⚠ Due time
        </div>
      )}
    </div>
  );
};
